import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

const ExtendedInputCheckbox = forwardRef(
  ({ name, id, className, state = 'default', disabled, readOnly, ...props }, ref) => {
    const cn = useClassNames(
      () => [
        'form-checkbox rounded border-1',
        !disabled && state === 'invalid' && 'border-red-600',
        !disabled && state === 'invalid' && 'text-red-600',
        !disabled && state === 'valid' && 'border-green-500',
        !disabled && state === 'valid' && 'text-green-500',
        className,
      ],
      [disabled, className, state],
    );
    return (
      <label
        htmlFor={id}
        className={`flex items-center justify-center w-8 h-8 ${
          readOnly ? 'pointer-events-none' : 'cursor-pointer'
        }`}
      >
        <input
          type="checkbox"
          name={name}
          id={id}
          className={cn}
          disabled={disabled}
          readOnly={readOnly}
          ref={ref}
          {...props}
        />
      </label>
    );
  },
);

ExtendedInputCheckbox.displayName = 'ExtendedInputCheckBox';

ExtendedInputCheckbox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  state: PropTypes.oneOf(['default', 'invalid', 'valid']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default ExtendedInputCheckbox;
